import { Link } from 'react-router-dom';
import { ArrowLeft, Lock } from 'lucide-react';

const S = {
  page: { minHeight: '100vh', background: '#f8fafc', fontFamily: "'Inter', system-ui, sans-serif" },
  header: { background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 24px' },
  headerInner: { maxWidth: 900, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 },
  content: { maxWidth: 900, margin: '0 auto', padding: '48px 24px 80px' },
  card: { background: '#fff', borderRadius: 20, border: '1px solid #e2e8f0', padding: '48px 48px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' },
  h1: { fontSize: 30, fontWeight: 800, color: '#0f172a', margin: '0 0 8px', letterSpacing: '-0.5px' },
  date: { fontSize: 13, color: '#64748b', margin: '0 0 40px', display: 'block', borderBottom: '1px solid #f1f5f9', paddingBottom: 28 },
  h2: { fontSize: 18, fontWeight: 700, color: '#1e293b', margin: '32px 0 12px' },
  p: { fontSize: 15, lineHeight: 1.8, color: '#334155', margin: '0 0 14px' },
  ul: { paddingLeft: 20, margin: '0 0 14px' },
  li: { fontSize: 15, lineHeight: 1.8, color: '#334155', marginBottom: 6 },
};

export default function Gizlilik() {
  return (
    <div style={S.page}>
      <header style={S.header}>
        <div style={S.headerInner}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#475569', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>
            <ArrowLeft size={16} /> Ana Sayfa
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/logo.png" alt="temiz-iz.com" style={{ width: 30, height: 30, borderRadius: 8, objectFit: 'contain' }} onError={e => e.target.style.display = 'none'} />
            <span style={{ fontWeight: 800, color: '#1d4ed8', fontSize: 15 }}>temiz-iz.com</span>
          </div>
        </div>
      </header>

      <div style={S.content}>
        <div style={S.card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <div style={{ width: 48, height: 48, borderRadius: 14, background: 'linear-gradient(135deg,#eff6ff,#dbeafe)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Lock size={24} color="#1d4ed8" />
            </div>
            <h1 style={S.h1}>Gizlilik Politikası</h1>
          </div>
          <span style={S.date}>Son güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}</span>

          <p style={S.p}>
            Bu Gizlilik Politikası, <strong>temiz-iz.com</strong> platformunu kullananların gizliliğini korumak amacıyla hazırlanmıştır. Platformumuzu kullanarak bu politikayı kabul etmiş sayılırsınız.
          </p>

          <h2 style={S.h2}>1. Topladığımız Bilgiler</h2>
          <p style={S.p}>Platformumuz üzerinden aşağıdaki bilgiler toplanmaktadır:</p>
          <ul style={S.ul}>
            <li style={S.li}><strong>Gönüllü olarak paylaşılan bilgiler:</strong> Anket yanıtları, ad, telefon numarası (opsiyonel)</li>
            <li style={S.li}><strong>Otomatik toplanan teknik veriler:</strong> IP adresi, tarayıcı türü, işletim sistemi, erişim zamanı</li>
            <li style={S.li}><strong>Çerezler:</strong> Oturum yönetimi ve tercih hatırlama amacıyla kullanılır</li>
          </ul>

          <h2 style={S.h2}>2. Çerez Politikası</h2>
          <p style={S.p}>Platformumuz aşağıdaki çerez türlerini kullanmaktadır:</p>
          <ul style={S.ul}>
            <li style={S.li}><strong>Zorunlu Çerezler:</strong> Sistemin çalışması için gerekli oturum çerezleri. Bunlar devre dışı bırakılamaz.</li>
            <li style={S.li}><strong>Tercih Çerezleri:</strong> Tema (aydınlık/karanlık mod) ve dil tercihleri gibi kullanıcı ayarlarını hatırlar.</li>
            <li style={S.li}><strong>Oturum Çerezleri:</strong> Güvenli giriş durumunu koruyan JWT token çerezleri.</li>
          </ul>
          <p style={S.p}>Tarayıcı ayarlarınızdan çerezleri yönetebilir veya engelleyebilirsiniz. Ancak bazı çerezlerin engellenmesi platformun işlevselliğini etkileyebilir.</p>

          <h2 style={S.h2}>3. Bilgilerin Kullanım Amacı</h2>
          <p style={S.p}>Topladığımız bilgiler şu amaçlarla kullanılmaktadır:</p>
          <ul style={S.ul}>
            <li style={S.li}>Temizlik hizmetleri memnuniyet analizleri yapmak</li>
            <li style={S.li}>Hizmet kalitesini ölçmek ve raporlamak</li>
            <li style={S.li}>Güvenli kimlik doğrulama sağlamak</li>
            <li style={S.li}>Kötüye kullanımı tespit etmek ve önlemek</li>
            <li style={S.li}>Yasal yükümlülükleri yerine getirmek</li>
          </ul>

          <h2 style={S.h2}>4. Bilgilerin Paylaşılması</h2>
          <p style={S.p}>
            Kişisel bilgileriniz, aşağıdaki durumlar dışında üçüncü taraflarla paylaşılmamaktadır:
          </p>
          <ul style={S.ul}>
            <li style={S.li}>İlgili kurum yöneticileri (anket sonuçları raporları)</li>
            <li style={S.li}>Yetkili kamu kurumları (yasal zorunluluk halinde)</li>
            <li style={S.li}>Altyapı hizmet sağlayıcıları (gizlilik sözleşmesi kapsamında)</li>
          </ul>
          <p style={S.p}>Bilgileriniz kesinlikle satılmamakta veya ticari amaçlarla üçüncü taraflarla paylaşılmamaktadır.</p>

          <h2 style={S.h2}>5. Veri Güvenliği</h2>
          <p style={S.p}>Verilerinizin güvenliğini sağlamak için aşağıdaki teknik önlemler uygulanmaktadır:</p>
          <ul style={S.ul}>
            <li style={S.li}>SSL/TLS ile şifreli veri iletimi (HTTPS)</li>
            <li style={S.li}>Güvenli JWT tabanlı kimlik doğrulama</li>
            <li style={S.li}>Bcrypt ile şifrelenmiş parola saklama</li>
            <li style={S.li}>Rate limiting ile brute-force koruması</li>
            <li style={S.li}>Düzenli güvenlik güncellemeleri</li>
          </ul>

          <h2 style={S.h2}>6. Üçüncü Taraf Bağlantılar</h2>
          <p style={S.p}>
            Platformumuz bazı üçüncü taraf servislere yönlendirme yapabilir (WhatsApp gibi). Bu servislerin gizlilik politikaları kendi sorumluluklarındadır ve temiz-iz.com bu politikalar için sorumluluk üstlenmez.
          </p>

          <h2 style={S.h2}>7. Çocukların Gizliliği</h2>
          <p style={S.p}>
            Platformumuz, 18 yaşın altındaki bireylere yönelik hizmet vermemektedir. 18 yaşın altındaki kişilerden bilerek kişisel veri toplanmamaktadır.
          </p>

          <h2 style={S.h2}>8. Politika Değişiklikleri</h2>
          <p style={S.p}>
            Bu Gizlilik Politikası zaman zaman güncellenebilir. Önemli değişiklikler olması halinde platformumuz üzerinden bildirim yapılacaktır. Politikanın güncel halini düzenli olarak incelemenizi öneririz.
          </p>

          <h2 style={S.h2}>9. İletişim</h2>
          <p style={S.p}>
            Gizlilik politikamıza ilişkin sorularınız için bizimle iletişime geçebilirsiniz:
          </p>
          <p style={S.p}><strong>E-posta:</strong> info@temiz-iz.com</p>

          <div style={{ marginTop: 36, padding: '16px 20px', background: '#eff6ff', borderRadius: 12, border: '1px solid #bfdbfe', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <span style={{ fontSize: 20 }}>🔒</span>
            <p style={{ ...S.p, margin: 0, color: '#1e40af', fontSize: 14 }}>
              Verileriniz güvende. temiz-iz.com, 6698 sayılı KVKK ve GDPR uyumlu altyapısıyla verilerinizi korur.{' '}
              <Link to="/kvkk" style={{ color: '#1d4ed8', fontWeight: 600 }}>KVKK Aydınlatma Metnini</Link> inceleyebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
